import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import Translator from '%app/js/common/services/translator';
import {
    CATEGORY_MARKETING,
    CATEGORY_NECESSARY,
    CATEGORY_STATISTICS,
} from '%paysera_service_agreement/js/CookiesUserAgreement/config/constants';
import useCookieConsentChoices from '%paysera_service_agreement/js/CookiesUserAgreement/hook/useCookieConsentChoices';
import CookieConsentCategoryTables from './CookieConsentCategoryTables';

const ROW_SX = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
    mt: 2,
};

const CHECKBOXES_SX = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 2,
};

function CookieConsentCategorySelection({ closeBanner }) {
    const { checkboxValues, handleCheckboxChange, acceptSelected } = useCookieConsentChoices(closeBanner);

    return (
        <Box data-testid="redesign-cookie-consent-category-selection">
            <Box sx={ROW_SX}>
                <Box sx={CHECKBOXES_SX}>
                    <FormControlLabel
                        control={(
                            <Checkbox
                                size="small"
                                name={CATEGORY_NECESSARY}
                                checked
                                disabled
                            />
                        )}
                        label={(
                            <Typography variant="body2">
                                {Translator.trans('service_agreement_cookies.category.necessary')}
                            </Typography>
                        )}
                    />
                    <FormControlLabel
                        control={(
                            <Checkbox
                                size="small"
                                name={CATEGORY_STATISTICS}
                                checked={checkboxValues[CATEGORY_STATISTICS]}
                                onChange={handleCheckboxChange}
                            />
                        )}
                        label={(
                            <Typography variant="body2">
                                {Translator.trans('service_agreement_cookies.category.statistics')}
                            </Typography>
                        )}
                    />
                    <FormControlLabel
                        control={(
                            <Checkbox
                                size="small"
                                name={CATEGORY_MARKETING}
                                checked={checkboxValues[CATEGORY_MARKETING]}
                                onChange={handleCheckboxChange}
                            />
                        )}
                        label={(
                            <Typography variant="body2">
                                {Translator.trans('service_agreement_cookies.category.marketing')}
                            </Typography>
                        )}
                    />
                </Box>
                <Button
                    variant="text"
                    color="secondary"
                    onClick={acceptSelected}
                    data-testid="redesign-cookie-consent-accept-selection"
                >
                    {Translator.trans('service_agreement_cookies.button.accept_selection')}
                </Button>
            </Box>
            <CookieConsentCategoryTables />
        </Box>
    );
}

CookieConsentCategorySelection.propTypes = {
    closeBanner: PropTypes.func.isRequired,
};

export default React.memo(CookieConsentCategorySelection);
